import { ModelSagres } from "../../model-sagres";
import { ModalidadeLicitacao } from "../modalidade-licitacao";
import { Contrato } from "./contrato";

export class ContratoRegistroPreco extends ModelSagres {
  IdContrato: number;
  NmOrgaoResp: string;
  SgUf: string;
  NmMunicipio: string;
  NrLicitacao: number;
  NrAnoLicitacao: number;
  IdModalidade: number;
  NrCnpjOrgaoResp: string;

  IdContratoNavigation: Contrato;
  IdModalidadeNavigation: ModalidadeLicitacao;
}